import { ActivityIndicator, Dimensions, Modal, PixelRatio, StyleSheet, Text, TextInput, View } from 'react-native'
import React, { useContext, useEffect, useRef, useState } from 'react'
import MoneyIcon from '../../icons/MoneyIcon';
import Colours from '../../utils/Colours';
import meezalogo from '../../../assets/me_red.png';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import ErrorAlertComp from '../../alertComp/ErrorAlertComp';
import { Image } from 'react-native';
import AppTextInput from '../../utils/ColourThemes/AppTextInput';
import AppContext from '../../context/AppContext';



const { width, height } = Dimensions.get('window');
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

// Function to adjust font size
const dynamicFontSize = (size) => {
    const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
    const newSize = size * scaleFactor;

    return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;



const TransactionDigitCodeScreen = ({ hideScreen, setTransactCodeCorrect, doingsAmount }) => {

    const { logOut } = useContext(AppContext)



    // const [focusedIndex, setFocusedIndex] = useState(0);
    const [isErrorCompVisible, setIsErrorCompVisible] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [focusedIndex, setFocusedIndex] = useState(null);
    const [code, setCode] = useState(['', '', '', '']);
    const inputRefs = useRef([]);

    const axiosPrivate = useAxiosPrivate()

    const handleChange = (text, index) => {
        if (/^\d?$/.test(text)) { // Only allow a single digit
            const newCode = [...code];
            newCode[index] = text;
            setCode(newCode);

            // Move to the next input if a digit is entered
            if (text && index < 3) {
                inputRefs.current[index + 1]?.focus();
            }

            if (index === 3 && text) {

                const passcode = newCode.join('');

                //console.log('passcode', passcode)
                // hideScreen();
                submitPassCode(passcode);
            }
        }
    };

    const handleKeyPress = ({ nativeEvent }, index) => {
        if (nativeEvent.key === 'Backspace' && !code[index] && index > 0) {
            // Move to the previous input on delete
            inputRefs.current[index - 1]?.focus();
        }
    };


    // const submitPassCode = async (passcode) => {

    //     //submit to verify passcode with server
    //     try {
    //         setIsLoading(true)
    //         const response = await axiosPrivate.post('/verifyPasscode/verifyPasscode', { passcode }
    //         )
    //         if (response.status === 200 || response.status === 201) {
    //             setTransactCodeCorrect(true)
    //             hideScreen()

    //         } else {
    //             setErrorMessage('Wrong transaction code. carefully check the code and try again. Note: your account will be blocked after 4 wrong attempts')
    //             setCode(['', '', '', ''])
    //             setIsErrorCompVisible(true)
    //         }
    //     } catch (error) {

    //         if (error.response) {
    //             console.error('Error response from server:', error.response.data);
    //             const errorMessages = error.response.data?.error || error.response.data?.message || 'Something went wrong';
    //             setErrorMessage(errorMessages);
    //             setCode(['', '', '', ''])
    //             setIsErrorCompVisible(true);

    //         }

    //     } finally {
    //         setIsLoading(false);
    //     }

    // }

    const submitPassCode = async (passcode) => {
        try {
            setIsLoading(true);
            const response = await axiosPrivate.post('/verifyPasscode/verifyPasscode', { passcode });

            if (response.status === 200) {
                setTransactCodeCorrect(true);
                hideScreen(); // success flow
            }
        } catch (error) {
            if (error.response) {
                const { type, message } = error.response.data;

                if (type === "LOCKED") {
                    // Account is locked, log the user out
                    logOut(); // <- make sure you import/use your logout function from AuthContext
                    setErrorMessage(message);
                } else if (type === "INVALID_PASSCODE") {
                    // Wrong attempt but not yet locked
                    setErrorMessage(message);
                    setCode(['', '', '', '']); // reset input
                } else {
                    // Fallback for unexpected errors
                    setErrorMessage(message || "Something went wrong");
                    setCode(['', '', '', '']);
                }

                setIsErrorCompVisible(true);
            }
        } finally {
            setIsLoading(false);
        }
    };




    return (
        <View>
            {/* <TopHeaderComponent headerText={'Enter Transaction Code'} hideScreen={hideScreen} /> */}
            {/* Logo Box with rounded edges */}
            <View style={styles.logoIconBox}>
                <Image
                    source={meezalogo} // replace with your logo path
                    style={styles.logoImage}
                />
                <Text style={{
                    fontSize: dynamicSize(16),
                    fontWeight: '600',
                    color: Colours.DARKGRAY,
                    textAlign: 'center',
                }}>
                    Meeza.
                </Text>
            </View>

            {/* <View style={styles.amtCaptionContainer}>
                <Text style={styles.doingsAmtCaption} >Amount </Text>
                <Text style={styles.doingsAmtTxtAmt} >{doingsAmount} </Text>
            </View> */}
            {doingsAmount ? (
                <View style={styles.amtCaptionContainer}>
                    <Text style={styles.doingsAmtCaption}>Amount</Text>
                    <Text style={styles.doingsAmtTxtAmt}>{doingsAmount}</Text>
                </View>
            ) : null}



            <View style={styles.textboxAmountContainer}>

                <View style={styles.textboxHeader}>
                    <Text style={styles.doingsAmtTxt} >Four Digit Code </Text>
                    <Text style={styles.demacation}>|:</Text>
                </View>

                <View style={styles.textBoxContainer}>
                    {code.map((digit, index) => (
                        <AppTextInput
                            key={index}
                            ref={(ref) => (inputRefs.current[index] = ref)}
                            style={[
                                styles.inputTxt,
                                focusedIndex === index && styles.focusedBorder,
                            ]}
                            keyboardType="numeric"
                            maxLength={1} // Only allow one character
                            value={digit}
                            onChangeText={(text) => handleChange(text, index)}
                            onKeyPress={(e) => handleKeyPress(e, index)}
                            onFocus={() => setFocusedIndex(index)}
                            onBlur={() => setFocusedIndex(null)}
                            textAlign="center"
                            secureTextEntry={true}
                        />
                    ))}


                    <View style={{ backgroundColor: Colours.DARKLIGHTGRAY, height: 30, width: 1, }}></View>
                    {isLoading ? (
                        <ActivityIndicator size="small" color={Colours.PRIMARY} />
                    ) : (

                        <MoneyIcon color={Colours.PRIMARY} height={dynamicSize(30)} width={dynamicSize(30)} />
                    )}
                </View>

            </View>
            <Modal
                visible={isErrorCompVisible}
                transparent={true}
                animationType="fade"
            >
                <ErrorAlertComp
                    message={errorMessage}
                    onClose={() => setIsErrorCompVisible(false)}
                />
            </Modal>
        </View>
    )
}

const styles = StyleSheet.create({

    logoIconBox: {
        backgroundColor: Colours.PRIMARY_LIGHTER,
        borderRadius: dynamicSize(16),
        padding: dynamicSpacing(16),
        alignItems: 'center',
        justifyContent: 'center',
        marginHorizontal: dynamicSpacing(20),
        marginTop: dynamicSpacing(20),
    },
    logoImage: {
        width: dynamicSize(70),
        height: dynamicSize(70),
        marginBottom: dynamicSpacing(8),
        borderRadius: dynamicSize(16),
        // resizeMode: 'contain',
    },

    amtCaptionContainer: {
        margin: dynamicSpacing(15),
        marginBottom: dynamicSpacing(20),
        // padding: dynamicSpacing(15),
        borderRadius: dynamicSize(15),
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: Colours.PRIMARY_LIGHTER,
    },

    textboxAmountContainer: {

        margin: dynamicSpacing(15),
        marginBottom: dynamicSpacing(40),
        padding: dynamicSpacing(15),
        borderRadius: dynamicSize(15),
        backgroundColor: 'white',
    },
    textboxHeader: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: dynamicSpacing(1),
    },
    doingsAmtTxt: {
        marginTop: dynamicSpacing(10),
        marginBottom: dynamicSpacing(15),
        fontSize: dynamicFontSize(15),
        color: Colours.DARKLIGHTGRAY,
        fontFamily: 'Sen-Bold',
    },
    doingsAmtCaption: {
        marginTop: dynamicSpacing(10),
        marginBottom: dynamicSpacing(5),
        fontSize: dynamicFontSize(15),
        color: Colours.DARKGRAY,
        fontFamily: 'Sen-Regular',
    },
    doingsAmtTxtAmt: {
        marginTop: dynamicSpacing(5),
        marginBottom: dynamicSpacing(10),
        fontSize: dynamicFontSize(17),
        color: Colours.PRIMARY,
        fontFamily: 'Sen-Bold',
    },
    demacation: {
        paddingLeft: dynamicSpacing(1),
        paddingBottom: dynamicSpacing(0),
        color: Colours.PRIMARY_LIGHT,
        fontFamily: 'Sen-Regular',
    },
    textBoxContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: dynamicSpacing(10),
    },
    inputTxt: {
        height: dynamicSize(40),
        width: dynamicSize(50),
        marginTop: dynamicSpacing(10),
        padding: dynamicSpacing(10),
        borderWidth: dynamicSize(2.5),
        borderColor: Colours.LIGHTGRAY,
        borderRadius: dynamicSize(7),
        fontFamily: 'Sen-Regular',
        fontSize: dynamicFontSize(20),
        backgroundColor: Colours.LIGHTGRAY,
        marginBottom: dynamicSpacing(10),
        marginRight: dynamicSpacing(10),
    },
    buttonGray: {
        borderRadius: dynamicSize(10),
        justifyContent: 'center',
        marginTop: dynamicSpacing(10),
        alignItems: 'center',
        height: dynamicSize(55),
        width: '100%',
        backgroundColor: Colours.DARKGRAY,
    },
    focusedBorder: {
        borderColor: Colours.PRIMARY,
        borderWidth: dynamicSize(2),
    },
})

export default TransactionDigitCodeScreen
